export function timeFormatter(inputTime, type = 'ymd') {
  if (inputTime <= 0) {
    return "";
  }
  let date = new Date(inputTime * 1);
  let y = date.getFullYear();
  let m = date.getMonth() + 1;
  m = m < 10 ? ('0' + m) : m;
  let d = date.getDate();
  d = d < 10 ? ('0' + d) : d;
  let h = date.getHours();
  h = h < 10 ? ('0' + h) : h;
  let minute = date.getMinutes();
  let second = date.getSeconds();
  minute = minute < 10 ? ('0' + minute) : minute;
  second = second < 10 ? ('0' + second) : second;
  if (type == 'ymd') {
    return `${y}-${m}-${d}`;
  }
  if (type == 'ymd-hms') {
    return `${y}-${m}-${d} ${h}:${minute}:${second}`;
  }
  if (type == 'ymd-hm') {
    return `${y}-${m}-${d} ${h}:${minute}`;
  }
}



// WEBPACK FOOTER //
// ./src/filters/index.js